import {Box, TextField, Typography} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import {useTranslation} from 'react-i18next';

export const SatelliteIdFilter = props => {
  const {t} = useTranslation();
  return (
    <Box
      sx={{
        width: '100%',
        py: 2,
      }}
    >
      <Typography
        gutterBottom
        sx={{
          display: 'block',
        }}
      >
        {t('satelliteIdFilter.label', 'Satellite ID')}
      </Typography>
      <Typography variant="caption">
        {t('satelliteIdFilter.caption')}
      </Typography>
      <TextField
        size="small"
        variant="outlined"
        placeholder={t('satelliteIdFilter.inputPlaceholder')}
        fullWidth
        margin="dense"
        onChange={props.onChange}
        value={props.satelliteId}
      />
    </Box>
  );
};

SatelliteIdFilter.propTypes = {
  onChange: PropTypes.func.isRequired,
  satelliteId: PropTypes.string,
};

export default SatelliteIdFilter;
